module.exports = __webpack_public_path__ + "static/InteractiveFulldomeIcon-05497716374937f6dbbedc895b7ec6fd.png";